export type ShapeKind = 'heart' | 'square' | 'octagon' | 'pill'
export type ColorKey = 'green' | 'pink' | 'orange' | 'purple'

export interface Stone {
  id: string
  shape: ShapeKind
  color: ColorKey
}

export interface Card {
  id: string
  stones: Stone[]
}

export const SHAPES: ShapeKind[] = ['heart', 'square', 'octagon', 'pill']
export const COLORS: ColorKey[] = ['green', 'pink', 'orange', 'purple']

export const COLOR_VALUES: Record<ColorKey, string> = {
  green: '#22b573',
  pink: '#ec4899',
  orange: '#f97316',
  purple: '#8b5cf6',
}

function randInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}

function makeStone(): Stone {
  return {
    id: Math.random().toString(36).slice(2),
    shape: pick(SHAPES),
    color: pick(COLORS),
  }
}

// Each card gets 2 to 4 DIFFERENT stones (no duplicate shape+color pair on one card)
function makeCard(): Card {
  const count = randInt(2, 4)
  const stones: Stone[] = []
  const seen = new Set<string>()
  let guard = 0
  while (stones.length < count && guard < 50) {
    guard++
    const s = makeStone()
    const key = `${s.shape}-${s.color}`
    if (seen.has(key)) continue
    seen.add(key)
    stones.push(s)
  }
  return { id: Math.random().toString(36).slice(2), stones }
}

// Random number of cards (between 6 and 12)
export function generateDeck(): Card[] {
  const count = randInt(6, 12)
  return Array.from({ length: count }, makeCard)
}

// Draw a single random card (2 to 4 different stones)
export function drawCard(): Card {
  return makeCard()
}
